export const truncateNumber = (inputNumber, digit = 2) => {
    let numberString = inputNumber.toString();
    numberString = numberString.slice(0, numberString.indexOf('.') + digit + 1);
    return Number(numberString);
};

export const checkValidNumber = (val) => {
    if (val === '' || val === null || val === undefined) return null;
    const value = Number(val);
    return Number.isFinite(value) ? value : null;
};
